import { getVal, getFirebase } from 'react-redux-firebase';

import { Board, Boards, StoreState } from '../../types';
import { OwnNewBoardProps, StateNewBoardProps } from './NewBoard';
import { authController } from '../../controller/auth';
import { RetroMode } from '../../constants/mode';
import * as firebase from 'firebase/app';
import { Crypto } from '../../util/crypto';

function initialBoardConfig(
  user: firebase.User,
  mode: RetroMode,
  secure: boolean = false
): Promise<Board> {
  const crypto = new Crypto();

  return Promise.all([crypto.initKeypair(), crypto.initSymmetricKey()]).then(
    async () => {
      return {
        public: {
          config: {
            secure
          }
        },
        private: {
          config: {
            sorted: false,
            creatorUid: user.uid,
            guided: true,
            guidedPhase: 0,
            timerExpiration: null,
            created: new Date().toISOString(),
            showAuthor: true,
            showCards: true,
            mode
          },
          cards: {},
          users: {
            [user.uid]: {
              name: user.displayName || '',
              image: user.photoURL || '',
              ready: false,
              publicKey: crypto.getPublicKey()!!
            }
          },
          keyStore: {
            [crypto.getPublicKey()!!]: await crypto.exportSymmetricKey(
              crypto.getPublicKey()!!
            )
          },
          presence: {}
        }
      };
    }
  );
}

let onSignIn = false;

export function mapStateToProps(
  state: StoreState,
  ownProps: OwnNewBoardProps
): StateNewBoardProps {
  const { fbState } = state;
  const firebase = getFirebase();

  const auth: firebase.User | any = onSignIn
    ? {}
    : firebase.auth().currentUser || {};

  const boards: Boards = getVal(fbState, 'data/boards', undefined);

  function onCreateNewBoard(mode: RetroMode, secure: boolean) {
    const auth = getFirebase().auth();
    initialBoardConfig(auth.currentUser!!, mode, secure).then(board => {
      getFirebase()
        .ref('/boards')
        .push(board)
        .then((item: any) => {
          const key = item.getKey();
          location.hash = `/board/${key}`;
        });
    });
  }

  function onLogin(email: string, mode: RetroMode, secure: boolean) {
    onSignIn = true;

    authController(firebase)
      .signInAnonymously(email)
      .then(() => {
        const { state = { referrer: null } } = ownProps.location;
        if (state.referrer) {
          location.assign(state.referrer);
        } else {
          onCreateNewBoard(mode, secure);
        }

        onSignIn = false;
      });
  }

  function onLogout() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        location.hash = '/new';
      });
  }

  return {
    boards,
    uid: auth.uid,
    onCreateNewBoard,
    onLogin,
    onLogout
  };
}
